export const retrieveUtm = (dataObj: any, key: string) => {
	const prefix: string = 'utm';
	if (dataObj[`${prefix}_${key}`]) {
		return dataObj[`${prefix}_${key}`];
	}
	if (dataObj[`${prefix}${key.charAt(0).toUpperCase() + key.slice(1)}`]) {
		return dataObj[`${prefix}${key.charAt(0).toUpperCase() + key.slice(1)}`];
	}
	if (dataObj[`${prefix}${key.toLowerCase()}`]) {
		return dataObj[`${prefix}${key.toLowerCase()}`];
	}
}

// calcolo in base a mese/giorno, evitando off-by-one
export const getAge = (birthDate: Date, asOf: Date = new Date()): number => {
  let years = asOf.getFullYear() - birthDate.getFullYear();
  const m = asOf.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && asOf.getDate() < birthDate.getDate())) {
    years--;
  }
  return years;
}

export const addMonthsSafe = (date: Date, months: number): Date => {
  // evita overflow (es. 31 → mese con meno giorni)
  const d = new Date(date);
  const day = d.getDate();
  d.setDate(1); // vai al giorno 1 per evitare salti
  d.setMonth(d.getMonth() + months);
  // ripristina il giorno, limitando all’ultimo del mese
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, lastDay));
  return d;
}

export const formatMonthYearIT = (date: Date, month: 'short' | 'long' = 'short'): string => {
  return formatDateIt(date, 'numeric', month, undefined, undefined, undefined)
}

export const formatDateIt = (date: Date,
  year: 'numeric' = 'numeric', 
  month: 'short' | 'long' = 'short', 
  day: '2-digit' | undefined = undefined, 
  hour: '2-digit' | undefined = undefined, 
  minute: '2-digit' | undefined = undefined
): string => {
  const s = new Intl.DateTimeFormat('it-IT', {
    day: day,
    month: month,
    year: year,
    hour: hour,
    minute: minute,
    timeZone: 'Europe/Rome'
  }).format(date);

  return s.charAt(0).toUpperCase() + s.slice(1);
}